import api from "./configuration";
import apiUrl from "./url";

const USE_AUTH_INTERCEPTOR = true;

export const ProspectPlayersReportAPI = {
	list: async (data) => {
		const response = await api.request({
			method: "GET",
			url: apiUrl + "/ProspectPlayersReports",
			useAuthInterceptor: USE_AUTH_INTERCEPTOR,
			params: data,
		});

		return response.data;
	},
	listByPlayerId: async (id) => {
		const response = await api.request({
			method: "GET",
			url: apiUrl + "/ProspectPlayersReports/Players/" + id,
			useAuthInterceptor: USE_AUTH_INTERCEPTOR,
		});

		return response.data;
	},
	listByMatchId: async (id) => {
		const response = await api.request({
			method: "GET",
			url: apiUrl + "/ProspectPlayersReports/Matches/" + id,
			useAuthInterceptor: USE_AUTH_INTERCEPTOR,
		});

		return response.data;
	},
	getById: async (id) => {
		const response = await api.request({
			method: "GET",
			url: apiUrl + "/ProspectPlayersReports/" + id,
			useAuthInterceptor: USE_AUTH_INTERCEPTOR,
		});

		return response.data;
	},
	create: async (data) => {
		const response = await api.request({
			method: "POST",
			url: apiUrl + "/ProspectPlayersReports",
			useAuthInterceptor: USE_AUTH_INTERCEPTOR,
			data,
		});

		return response.data;
	},
	update: async (id, data) => {
		const response = await api.request({
			method: "PUT",
			url: apiUrl + "/ProspectPlayersReports/" + id,
			useAuthInterceptor: USE_AUTH_INTERCEPTOR,
			data,
		});

		return response.data;
	},
	delete: async (id) => {
		const response = await api.request({
			method: "DELETE",
			url: apiUrl + "/ProspectPlayersReports/" + id,
			useAuthInterceptor: USE_AUTH_INTERCEPTOR,
		});

		return response.data;
	},
};
